import { render, staticRenderFns } from "./ViewMenu.vue?vue&type=template&id=892ba92e&"
import script from "./ViewMenu.vue?vue&type=script&lang=js&"
export * from "./ViewMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports